module.exports = __webpack_public_path__ + "media/images/icons/vendors/cakes-d93e1382822a33be2ebb8a490397f466.png";